import { createSlice } from '@reduxjs/toolkit';

import { uploadProductCatalogue, getVendorCatalogues, downloadSampleProductCatalogue, downloadVendorCatalogue } from '../../apis';

export const ChinaCatalogueReviewSlice = createSlice({

    name: 'ChinaCatalogueReviewManagement',
    initialState: {
        isLoading: false,
        catalogueData : [],
        catalogueError: false,
        uploadCatalogueFileSuccess: false,
        downloadCatalogueUrl: ''
    },

    reducers: {
        clearCatalogue: (state, action) => {
            return {
                ...state,
                [action.payload.key]: action.payload.value
            }
        }
    },

    extraReducers: (builder) => {
        builder.addCase(getVendorCatalogues.pending, (state, action) => {
            state.catalogueData = [];
            state.isLoading = true;
        })
        builder.addCase(getVendorCatalogues.fulfilled, (state, action) => {
            state.isLoading = false;
            state.catalogueError = '';
            state.catalogueData = action.payload.data;
        })
        builder.addCase(getVendorCatalogues.rejected, (state, action) => {
            state.catalogueError = action.payload.message
            state.isLoading = false;
        })
        builder.addCase(uploadProductCatalogue.pending, (state, action) => {
            state.isLoading = true;
        })
        builder.addCase(uploadProductCatalogue.fulfilled, (state, action) => {
            state.isLoading = false;
            state.catalogueError = '';
            state.uploadCatalogueFileSuccess = true;
        })
        builder.addCase(uploadProductCatalogue.rejected, (state, action) => {
            state.catalogueError = action.payload.message
            state.isLoading = false;
        })
        builder.addCase(downloadSampleProductCatalogue.pending, (state, action) => {
            state.isLoading = true;
        })
        builder.addCase(downloadSampleProductCatalogue.fulfilled, (state, action) => {
            state.isLoading = true;
            state.catalogueError = '';
            state.downloadCatalogueUrl = action.payload.data;
        })
        builder.addCase(downloadSampleProductCatalogue.rejected, (state, action) => {
            state.catalogueError = action.payload.message
            state.isLoading = false;
        })
        builder.addCase(downloadVendorCatalogue.pending, (state, action) => {
            state.isLoading = true;
        })
        builder.addCase(downloadVendorCatalogue.fulfilled, (state, action) => {
            state.isLoading = true;
            state.catalogueError = '';
            state.downloadCatalogueUrl = action.payload.data;
        })
        builder.addCase(downloadVendorCatalogue.rejected, (state, action) => {
            state.catalogueError = action.payload.message
            state.isLoading = false;
        })
    }
})

export const { clearCatalogue } = ChinaCatalogueReviewSlice.actions
export default ChinaCatalogueReviewSlice.reducer